interface SectionTitleProps {
  en: string;
  ja: string;
  light?: boolean;
  centered?: boolean;
}

export default function SectionTitle({ en, ja, light = false, centered = true }: SectionTitleProps) {
  return (
    <div className={`mb-10 md:mb-14 ${centered ? "text-center" : ""}`}>
      <span className={`text-sm tracking-[3px] font-bold block mb-2 ${light ? "text-gold" : "text-gold"}`}>
        {en}
      </span>
      <h2 className={`text-2xl md:text-3xl font-bold ${light ? "text-white" : "text-navy"}`}>
        {ja}
      </h2>
    </div>
  );
}